import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Handle PocketBase password reset URLs with /_/#/ format
    const pathname = location.pathname;
    const hash = location.hash;
    
    console.log('RedirectHandler - pathname:', pathname, 'hash:', hash);
    
    // Check if this is a PocketBase password reset URL
    if (hash && hash.includes('/auth/confirm-password-reset/')) {
      // Extract the token from the hash
      const hashPath = hash.substring(1); // Remove the # character
      console.log('Redirecting to:', hashPath);
      navigate(hashPath, { replace: true });
    } else if (pathname.startsWith('/_/') && hash) {
      // Handle other /_/#/ URLs by redirecting to the hash path
      const hashPath = hash.substring(1); // Remove the # character
      console.log('Redirecting from /_/ to:', hashPath);
      navigate(hashPath, { replace: true });
    } else {
      // If it's not a recognized format, redirect to home
      console.log('Unrecognized URL format, redirecting to home');
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h2 className="text-lg font-semibold mb-2">Redirecting...</h2>
        <p className="text-muted-foreground">Please wait while we redirect you to the correct page.</p>
      </div>
    </div>
  );
};

export default RedirectHandler;